// Leather-bound book cover — generated from a script title at upload time.
// Matches the look in Ryan's MagicPatterns Shelf reference (leather + brass
// rivets + gold-foil title + manuscript rule). The PWA renders this in CSS
// rather than fetching pre-rendered cover images, so any newly uploaded
// script gets a real-looking cover immediately, no art commission needed.
import { CSSProperties } from "react";

export type LeatherTheme =
  | "olive" | "black" | "navy" | "burgundy" | "tan";

export interface BookProps {
  title:    string;
  byline?:  string;      // "by Anton Chekhov"
  theme?:   LeatherTheme;
  style?:   CSSProperties;
  width?:   number;      // px override
}

// Deterministic theme assignment from a string so the same script always
// wears the same leather across sessions.
export function leatherFor(seed: string): LeatherTheme {
  const opts: LeatherTheme[] = ["olive", "black", "navy", "burgundy", "tan"];
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return opts[h % opts.length];
}

function titleClass(title: string): string {
  const len = title.length;
  if (len <= 12) return "v2-title-short";
  if (len <= 22) return "v2-title-medium";
  return "v2-title-long";
}

export default function Book({ title, byline, theme, style, width }: BookProps) {
  const t = theme || leatherFor(title);
  const styleVars: CSSProperties = width
    ? { ...style, ["--cover-w" as any]: `${width}px`, ["--cover-h" as any]: `${Math.round(width * 1.58)}px` }
    : style || {};
  return (
    <div
      className={`v2-leather v2-leather-${t} v2-cover-w172`}
      style={styleVars}
    >
      <div className="v2-leather-spine" />
      <div className="v2-leather-rule" />
      <div className="v2-leather-rivet v2-rivet-top" />
      <div className="v2-leather-rivet v2-rivet-middle" />
      <div className="v2-leather-rivet v2-rivet-bottom" />
      <div className="v2-leather-content">
        <div className={`v2-leather-title ${titleClass(title)}`}>
          {title.toUpperCase().split(/\s+/).map((word, i) => (
            <span key={i}>{word}</span>
          ))}
        </div>
        <div className="v2-leather-divider" />
        {byline && <div className="v2-leather-byline">{byline}</div>}
      </div>
    </div>
  );
}
